export default __webpack_public_path__ + "static/media/whitedress.1790b7e1.jpg";